import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';

class ScrollToTop extends PureComponent {
  componentDidUpdate(prevProps) {
    const isCustomerDetail = get(this, 'props.location.pathname', '').includes('/app/customer/');

    if (this.props.location !== prevProps.location && !isCustomerDetail) {
      window.scrollTo(0, 0)
    }

    const { location: { pathname } } = this.props;
    const previousLocation = prevProps.location.pathname;

    if (pathname !== previousLocation && window.Appcues) {
      window.Appcues.page();
    }
  }

  render() {
    return this.props.children
  }

} // END ScrollToTop

ScrollToTop.propTypes = {
  location: PropTypes.any,
  'location.pathname': PropTypes.any,
  children: PropTypes.any,
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/app/ScrollToTop.js